import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { PAGE_CONFIG } from "../../../common/constant/pageconfig.constant";
import { ComplainInterface } from "../../complain.interface";
import { COMPLAINT_CONSTANT } from '../constant/complaint.constant';

@Injectable({
  providedIn: "root",
})
export class ComplaintService {
  requestOptions = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "my-auth-token",
    }),
    body: {},
  };

  constructor(private httpClient: HttpClient) {}

  // Updated APIS

  public updateData(complainData: ComplainInterface) {
    let complainId = complainData.id;
    return this.httpClient.put(
      `${COMPLAINT_CONSTANT.COMPLAINT_SOFT_DELETE}/${complainId}`,
      complainData
    );
  }

  public getComplaintDataByStatus(status: string, obj) {
    if(obj.page === null || obj.page === undefined){
      obj.page = {
        number: 0,
        size: 3,
      }
    }
    return this.httpClient.post(
      `${COMPLAINT_CONSTANT.COMPLAINT_LIST}/${status}`,
      obj
    );
  }

  public ComplaintDataByStatus(status: string) {
    return this.httpClient.post(
      `${COMPLAINT_CONSTANT.COMPLAINT_LIST}/${status}`,
      {}
    );
  }

  public getComplaintCountByStatus() {
    return this.httpClient.get(`${COMPLAINT_CONSTANT.COUNT_BY_STATUS}`);
  }

  public getComplaintCount() {
    return this.httpClient.get(`${COMPLAINT_CONSTANT.COMPLAIN_COUNT}`);
  }

  public updateComplainStatus(data) {
    return this.httpClient.put(
      `${COMPLAINT_CONSTANT.COMPLAINT_DATA}/${data.id}`,
      data
    );
  }

  public getVisitorComplains(complaintId: any) {
    return this.httpClient.get(
      `${COMPLAINT_CONSTANT.VISITORS_COMPLAINS}/${complaintId}`
    );
  }

  public addComment(data) {
    return this.httpClient.post(
      `${COMPLAINT_CONSTANT.COMPLAINT_ADD_COMMENT}`,
      data
    );
  }

  public getTotalCount() {
    return this.httpClient.get(`${COMPLAINT_CONSTANT.TOTAL_COUNT}`);
  }

  // Old APS

  public getComplaintDataByOfficeId() {
    return this.httpClient.get(`${COMPLAINT_CONSTANT.COMPLAINT_LIST}`);
  }

  public dashboardRecentComplains() {
    return this.httpClient.get(`${COMPLAINT_CONSTANT.ADMIN_RECENT_COMPLAINT}`);
  }

  public createComplaintData(complaintData: ComplainInterface) {
    return this.httpClient.post(
      COMPLAINT_CONSTANT.COMPLAINT_DATA,
      complaintData
    );
  }

  public getComplaintEdit(complaintId: any) {
    return this.httpClient.get(
      `${COMPLAINT_CONSTANT.COMPLAINT_DATA}/${complaintId}`
    );
  }

  public updateComplaintData(complaintData: ComplainInterface) {
    let complaintId = complaintData.id;
    return this.httpClient.put(
      `${COMPLAINT_CONSTANT.COMPLAINT_DATA}/${complaintId}`,
      complaintData
    );
  }

  public deleteComplaintData(complaint: any) {
    this.requestOptions.body = complaint;
    return this.httpClient.delete(
      `${COMPLAINT_CONSTANT.COMPLAINT_DATA}`,
      this.requestOptions
    );
  }

  // voter search

  public searchVoter(voterObj) {
    let voterSearchObj = { filters: voterObj };
    return this.httpClient.post(
      COMPLAINT_CONSTANT.VOTER_SEARCH,
      voterSearchObj
    );
  }

  // other API

  public getCategoryData() {
    return this.httpClient.get(COMPLAINT_CONSTANT.CATEGORY_LIST);
  }

  public getAssemblyData() {
    return this.httpClient.get(`${COMPLAINT_CONSTANT.ASSEMBLIES_LIST}`);
  }

  public getGaonData(assemblyId: any) {
    return this.httpClient.get(`${COMPLAINT_CONSTANT.GAON_LIST}/${assemblyId}`);
  }

  public getGatNumberData(gatId: any) {
    return this.httpClient.get(`${COMPLAINT_CONSTANT.GATNO_LIST}/${gatId}`);
  }

  public getGanNumberData(ganId: any) {
    return this.httpClient.get(
      `${COMPLAINT_CONSTANT.GAN_NUMBER_LIST}/${ganId}`
    );
  }
  public getCast() {
    return this.httpClient.get(`${COMPLAINT_CONSTANT.CAST}`);
  }

  public getsubCastwithCast(castId: any) {
    return this.httpClient.get(
      `${COMPLAINT_CONSTANT.SUBCAST_WITH_CAST}/${castId}`
    );
  }

  searchVisitor(visitorInfo) {
    return this.httpClient.get(
      `${COMPLAINT_CONSTANT.VISITOR_SEARCH}/${visitorInfo}`
    );
  }

  public getPageConfig() {
    return this.httpClient.get(PAGE_CONFIG.Complaint_Page);
  }

  public getCSV(payload) {
    return this.httpClient.post(`/complainbox/export`, payload, {
      headers: { Accept: "application/pdf" },
      responseType: "blob",
    });
  }
  
  public getExcelFields() {
    return this.httpClient.get<any[]>(`/complainbox/export/fields`);
  }
  public restoreRecord(rowData: any) {
    return this.httpClient.patch(`/complainbox/restore/${rowData.id}`, {});
       }

}
